<template>
  <div class="">
    <p>بازه زمانی رزرو محصول</p>
    <date-picker
        v-model="reservationRange"
        range
        @change="orderReservationFilter()"
        clearable
        auto-submit
        format="YYYY-MM-DD"
        display-format="jMMMM jD"
    />
  </div>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  name: "Reservation",
  components: {datePicker: VuePersianDatetimePicker,},
  data() {
    return {
      reservationRange: ''
    }
  },
  methods: {
    orderReservationFilter() {
      let reservation = this.reservationRange
      reservation[0] = `${reservation[0]} 00:00:00`
      reservation[1] = `${reservation[1]} 23:59:59`
      reservation = reservation.sort().join(',')
      this.$store.commit("ShoppingCart/setFilters", {key: "reservation", value: reservation});
      this.$store.dispatch('ShoppingCart/getAllOrders', 1)
    },
  }
}
</script>

<style scoped>

</style>